(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ep-brand-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.epBrandHeaderInstalled) return;
  window.epBrandHeaderInstalled = true;
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const details = event.target.closest('.ep-brand-disclosure[open]');
    if (details) { details.open = false; details.querySelector('summary').focus(); }
  });
  document.addEventListener('click', event => {
    if (event.target.closest('.ep-brand-mobile-nav a')) event.target.closest('.ep-brand-disclosure').open = false;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
